import React from "react";
import {
  Typography,
  CardMedia,
  Button,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import { FONT_SECONDARY } from "@/theme/typography";
import { types } from "@/utils/staticData/aboutUsData";
import useResponsive from "@/hooks/useResponsive";

import Arrow_square_icon from "@/assets/icons/about-us/arrow-up-on-square.svg?react";
import Square_stack_icon from "@/assets/icons/about-us/square-stack.svg?react";
import { buttonStyles, iconStyles, imageStyles } from "./styles";

interface IProps {
  title: string;
  subtitle: string;
  iconUrl: string;
  type: string;
}

const JoinNetworkCard: React.FC<IProps> = ({
  title,
  subtitle,
  iconUrl,
  type,
}) => {
  const isSmallMobile = useMediaQuery("(max-width: 374.98px)");
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();

  return (
    <Box
      p={isSmallMobile ? 1.5 : 2}
      bgcolor="white"
      borderRadius={3}
      boxSizing="border-box"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      boxShadow={theme.customShadows.resources}
      minHeight={{ xs: 208, md: 222 }}
      height={"100%"}
    >
      <Box>
        <CardMedia
          component="img"
          image={iconUrl}
          alt={title}
          sx={imageStyles}
        />

        <Typography
          variant="caption"
          component="p"
          fontWeight={700}
          fontSize={14}
          mb={2}
        >
          {title}
        </Typography>
        <Typography
          variant="caption"
          component="p"
          fontFamily={FONT_SECONDARY}
          fontWeight={500}
          fontSize={12}
          mb={3}
          color="text.secondary"
        >
          {subtitle}
        </Typography>
      </Box>

      <Box>
        {type === types.request && (
          <Button
            fullWidth
            size={isMobile ? "small" : "large"}
            variant="contained"
            disabled
            sx={buttonStyles}
          >
            Apply now
          </Button>
        )}
        {type === types.recommend && (
          <Box display="flex" gap={1}>
            <Box sx={iconStyles}>
              <Square_stack_icon />
            </Box>
            <Box sx={iconStyles}>
              <Arrow_square_icon />
            </Box>
          </Box>
        )}
        {type === types.earn && (
          <Box
            borderRadius={{ xs: 1, md: 2 }}
            bgcolor="#F9FAFC"
            py={{ xs: 0.5, md: 1.25 }}
            px={{ xs: 0.75, md: 1.5 }}
          >
            <Typography variant="caption" component="p" fontWeight={700}>
              Total
            </Typography>
            <Typography
              variant="caption"
              component="p"
              fontWeight={700}
              fontSize={{ xs: 14, md: 16, lg: 18 }}
            >
              $20,000
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default JoinNetworkCard;
